import { styled as r } from "styled-components";
import { Colors as e } from "../../styles/colors/index.js";
import { Theme as o } from "../../styles/themes/index.js";
import { MediaQuery as i } from "../../styles/variables.js";
import { Icon as t } from "../Icon/index.js";
const m = r.div`
  position: absolute;
  top: -6px;
`, b = r.div`
  display: flex;
  width: 100%;
  align-items: center;
  column-gap: 2px;

  @media ${i.SCREEN_MD_UP} {
    max-width: 620px;
  }
`, x = r(t)`
  color: rgb(${e.Red});
  font-size: 24px;
`, h = r(t)`
  color: rgb(${e.Blue});
  font-size: 24px;
`, u = r.div`
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background: rgb(${o.colors.Alpha});
  border: 3px solid rgb(${o.colors.Juliet});
`, d = r.div`
  display: flex;
  justify-content: center;
  height: 4px;
  width: 25%;
  background: linear-gradient(
    90deg,
    rgb(${e.Blue}) 0%,
    rgb(${e.Blue}) 50%,
    rgb(${e.Alien}) 100%
  );
  border-radius: 4px;
`, n = r.div`
  display: flex;
  justify-content: center;
  height: 4px;
  width: 25%;
  background: linear-gradient(
    90deg,
    rgb(${e.Tangerine}) 0%,
    rgb(${e.Red}) 50%,
    rgb(${e.Red}) 100%
  );
  border-radius: 4px;
`, a = r.div`
  display: flex;
  justify-content: center;
  height: 4px;
  width: 50%;
  background: rgb(${e.Yellow});
  border-radius: 4px;
`, f = r.div`
  display: flex;
  width: 100%;
  column-gap: 4px;
  position: relative;

  &[data-disabled='true'] {
    ${d}, ${a}, ${n} {
      background: rgb(${e.Silver});
    }
  }
`;
export {
  u as Dot,
  m as DotWrapper,
  x as FireIcon,
  h as SnowflakeIcon,
  d as ThermometerColdArea,
  f as ThermometerContainer,
  n as ThermometerHotArea,
  a as ThermometerNormalArea,
  b as ThermometerWrapper
};
